import React, { useState } from "react";
import { LeaderboardMetric, MenuType } from "@/types/leader-board";
import UserLeaderBoardInfo from "./user-leader-board-info";
import Button from "@/components/atomics/button";
import ModalCard from "@/components/atomics/modal-card";

interface LeaderBoardBoostProps {
  className?: string;
  userInfo: any;
  selectedMenu: MenuType;
  metric: LeaderboardMetric;
  onClickSendStar: (rating: number) => void;
  onClickClose: () => void;
}

export default function LeaderBoardRankInfo({
  className,
  userInfo,
  selectedMenu,
  metric,
  onClickClose,
}: LeaderBoardBoostProps) {
  const getShareTitle = () => {
    switch (selectedMenu) {
      case "users":
        return "user";
      case "collections":
        return "collect.";
    }
  };
  return (
    <ModalCard title="rank info" onClose={onClickClose} className={className}>
      <div className="flex flex-col px-[54px] py-[20px]">
        <span className="text-[23px] uppercase">{getShareTitle()} {metric} rank</span>
      </div>

      <UserLeaderBoardInfo
        className=" !bg-[#2B2B2B]"
        circleColor="#2B2B2B"
        userInfo={userInfo}
        selectedMenu={selectedMenu}
        metric={metric}
      />

      <main className=" flex flex-col justify-center items-center pt-[25px] pb-[30px] pl-[54px] pr-[54px] text-[24px]">
        <Button
          className="w-full custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
          image="/assets/button.svg"
          text="OK"
          onClick={onClickClose}
        />
      </main>
    </ModalCard>
  );
}
